import { createSlice } from '@reduxjs/toolkit'
import { accEntryCommentView, destroyComments } from './accEntry-comment.actions'
import { combineReducers } from 'redux'
type CommentsState = {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  error: string | null
  data: unknown[]
}

const initialState: CommentsState = {
  status: 'idle',
  error: null,
  data: [],
}

const CommentsSlice = createSlice({
  name: 'commentsSlice',
  initialState: initialState,
  reducers: {
    [destroyComments.toString()]: (state) => {
      state = initialState
    },
  },
  extraReducers: {
    [accEntryCommentView.pending.toString()]: (state) => {
      state.status = 'loading'
      state.data = []
    },
    [accEntryCommentView.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
      state.data = action.payload
      state.error = null
    },
    [accEntryCommentView.rejected.toString()]: (state, action) => {
      state.status = 'failed'
      state.data = []
      state.error = action.payload
    },
  },
})

export default CommentsSlice.reducer

export const commentsReducer = combineReducers({
  comments: CommentsSlice.reducer,
})
